import React, { useRef, useState } from "react";
import { useTypedSelector } from "../../../../../store/reducers/use-typed-selector";

import BasicCard from "../../../../general-ui/basic-card/basic-card";

import './broadcast-card.scss';
import Icon, { COLORS, ICONS } from "../../../../general-ui/icon";
import WaitingIndicator from "../../../../general-ui/waiting-indicator/waiting-indicator";
import { UploadFile } from "../../../../../connection/uploads";
import BroadcastOptionsModal from "./broadcast-options-modal";
import classNames from 'classnames';
import { useCallback } from "react";
import FileInput from "../../../../../utils/file-input";
interface IUploadButtonProps {
	uploadedImage: (uploadedImage: string) => void;
	onStartUpload: () => void;
	initialImage?: string;
	handleDeleteImage: (setUploadedUri: React.Dispatch<React.SetStateAction<string | undefined>>) => void;
	smaller?: boolean;
	description?: string;
	title?: string;
	uploadIcon?: JSX.Element;
	disabled?: boolean;
}

export const UploadButton: React.FC<IUploadButtonProps> = ({
	uploadedImage,
	onStartUpload,
	initialImage,
	handleDeleteImage,
	smaller = false,
	description,
	title,
	uploadIcon,
	disabled = false
}) => {
	const user = useTypedSelector(state => state.AuthReducer.user);
	const token = useTypedSelector(state => state.AuthReducer.token);

	const [uploading, setUploading] = useState(false);
	const [uploadedUri, setUploadedUri] = useState<string | undefined>(initialImage || undefined);

	const uploadImageInput = useRef<HTMLInputElement | null>(null);
	const replaceImageInput = useRef<HTMLInputElement | null>(null);

	const onUploadClick = () => {
		if (uploadImageInput?.current) {
			uploadImageInput.current.click();
		}
	};

	const onReplaceClick = () => {
		if (replaceImageInput?.current) {
			replaceImageInput.current.click();
		}
	};

	const uploadImage = async (imageFile: File) => {
		if (!user || !token) return;
		if (imageFile instanceof File) {
			onStartUpload();
			setUploading(true);
			try {
				const uploaded = await UploadFile(user, token, imageFile);
				setUploadedUri(uploaded);
				uploadedImage(uploaded);
			} catch (e: any) {
				console.log(e?.response || e);
			}
			setUploading(false);
		}
	};

	const handleUploadImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files) {
			uploadImage(e.target.files[0]);
		}
	};

	const handleDeleteImageInner = useCallback(() => {
		setUploadedUri(undefined);
		handleDeleteImage(setUploadedUri);
	}, [handleDeleteImage]);

	return (
		<div className={classNames("upload-image", { smaller })}>
			{initialImage || uploadedUri ? (
				<div>
					<div className="thumbnail-with-actions-container">
						<img width="80" height="48" src={initialImage || uploadedUri} alt="thumbnail" />
						<div className="thumbnail-actions">
							<button disabled={disabled} onClick={onReplaceClick} className="clear no-style"><Icon name={ICONS.EDIT} size={16} color={COLORS.WHITE} /></button>
							<button disabled={disabled} onClick={handleDeleteImageInner} className="clear no-style"><Icon name={ICONS.TRASH} size={16} color={COLORS.WHITE} /></button>
						</div>
					</div>
					<FileInput
						accept={['image/png', 'image/jpg', 'image/jpeg']}
						type="file"
						style={{ display: 'none' }}
						ref={replaceImageInput}
						onChange={handleUploadImageChange}
					/>
				</div>
			) : (
				<>
					<button
						onClick={onUploadClick}
						className="no-style clear soft-btn-radius broadcast-image-upload-button"
						disabled={uploading || disabled}
					>
						<div>
							<div className="upload-btn-title">
								{uploadIcon ? (uploadIcon) : (
									<Icon name={ICONS.ADD} size={16} color={COLORS.WHITE} />
								)}
								<span className={'upload-text-title'}>{title ?? 'Upload Image'}</span>
							</div>
							{description ? (
								<p className="upload-btn-paragraph">{description}</p>
							) : (
								<p className="upload-btn-paragraph">Accepted file types are .png, .jpeg, and up to 10 MB file size</p>
							)}
						</div>
						{uploading ? <div className="broadcast-image-upload-uploading"><WaitingIndicator /></div> : null}
					</button>
					<FileInput
						accept={['image/png', 'image/jpg', 'image/jpeg']}
						type="file"
						style={{ display: 'none' }}
						ref={uploadImageInput}
						onChange={handleUploadImageChange}
					/>
				</>
			)}
		</div>
	);
};

const BroadcastCard: React.FC = () => {
	const [open, setOpen] = useState(false);

	const handleOpen = () => setOpen(true);

	return (
		<div className="broadcast-card-container">
			<BasicCard className="session-module-broadcast-item" p={0}>
				<div className="session-display-card">
					Session Display
					<button className="no-style options" onClick={handleOpen}>
						<Icon name={ICONS.EDIT} size={20} color={'cyan'} />
					</button>
				</div>
			</BasicCard>
			<BroadcastOptionsModal
				isOpen={open}
				onClose={() => setOpen(false)}
			/>
		</div>
	);
};

export default BroadcastCard;
